import {CallPopup} from "@/components/popups/requestPopups/CallPopup";
import {ControlButton} from "@/components/ui/buttons/ControlButton";
import {BorderArticle} from "@/components/ui/general/BorderArticle";

import React from "react";

import {usePopup} from "@layouts/popup/InfoPopup/PopupContext";
import {RootButton} from "@ui/buttons/RootButton";
import {RootDesc} from "@ui/descriptions/RootDesc";
import {H3} from "@ui/titles/H3";
import {useTranslation} from "react-i18next";

import {useEffectivenessContext} from "./EffectivenessContext";
import styles from "./styles.module.scss";

export const Calc = ({onPrint}) => {
  const {openPopup} = usePopup();
  const {t} = useTranslation();
  const {
    currencySymbol,
    scenarioValues,
    repsCount,
    setRepsCount,
    minReps,
    maxReps,
    formatInteger,
  } = useEffectivenessContext();

  const handleOpenPopup = () => {
    openPopup(<CallPopup />);
  };

  const calcData = [
    {
      id: 0,
      title: t("page.effectiveness.calc.cards.investment.title"),
      value: `${currencySymbol}${formatInteger(scenarioValues.revised.investment)}`,
      description: t("page.effectiveness.calc.cards.investment.description"),
    },
    {
      id: 1,
      title: t("page.effectiveness.calc.cards.benefits.title"),
      value: `${currencySymbol}${formatInteger(scenarioValues.revised.benefits)}`,
      description: t("page.effectiveness.calc.cards.benefits.description"),
    },
    {
      id: 2,
      title: t("page.effectiveness.calc.cards.net_roi.title"),
      value: `${currencySymbol}${formatInteger(scenarioValues.revised.benefit)}`,
      description: t("page.effectiveness.calc.cards.net_roi.description"),
    },
    {
      id: 3,
      title: t("page.effectiveness.calc.cards.roi.title"),
      value: `${Math.round(scenarioValues.revised.roi)}%`,
      description: "",
    },
  ];

  return (
    <BorderArticle>
      <div className={"flex w-full items-center justify-between"}>
        <H3>{t("page.effectiveness.summary_title")}</H3>

        <div className={"flex items-center gap-[16rem]"}>
          <ControlButton
            color={"var(--green)"}
            txt={t("button.print")}
            onClick={onPrint}
            className={"h-[min-content]"}
          />

          <RootButton
            txt={t("button.personal_quote")}
            onClick={handleOpenPopup}
          />
        </div>
      </div>

      <hr />

      <div style={{width: "100%", position: "relative", zIndex: 1}}>
        <BorderArticle style={{padding: "0"}}>
          <div className={styles.effectiveness_calc}>
            <div className={styles.effectiveness_range_wrapper}>
              <RootDesc>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "16rem",
                  }}
                >
                  <b
                    style={{
                      color: "#fff",
                      fontSize: "23rem",
                      lineHeight: "120%",
                    }}
                  >
                    {t("page.effectiveness.calc.medical_reps")}
                  </b>
                  <span
                    style={{
                      color: "#fff",
                      fontSize: "23rem",
                      fontWeight: "400",
                      lineHeight: "120%",
                    }}
                  >
                    {repsCount}
                  </span>
                </div>
              </RootDesc>

              <div className={styles.effectiveness_range}>
                <div className={styles.effectiveness_range_track} />
                <input
                  type={"range"}
                  min={minReps}
                  max={maxReps}
                  step={10}
                  value={repsCount}
                  onChange={(e) => setRepsCount(Number(e.target.value))}
                  className={styles.effectiveness_range_input}
                />
                <div
                  className={styles.effectiveness_range_thumb}
                  style={{
                    left: `${maxReps > 0 ? (repsCount / maxReps) * 100 : 0}%`,
                  }}
                />
                <div className={styles.effectiveness_range_labels}>
                  <span>{minReps}</span>
                  <span>{maxReps}</span>
                </div>
              </div>
            </div>

            <RootDesc>
              <div className={styles.effectiveness_period}>
                <b
                  style={{
                    color: "#fff",
                    fontSize: "23rem",
                    lineHeight: "120%",
                  }}
                >
                  {t("page.effectiveness.calc.period")}
                </b>
                <span
                  style={{
                    color: "#fff",
                    fontSize: "23rem",
                    fontWeight: "400",
                    lineHeight: "120%",
                  }}
                >
                  {t("page.effectiveness.calc.period_value")}
                </span>
              </div>
            </RootDesc>
          </div>
        </BorderArticle>
      </div>

      <hr />

      <div className={styles.effectiveness_calc_summary}>
        {calcData.map((item) => (
          <React.Fragment key={item.id}>
            <BorderArticle>
              <RootDesc>
                <b className={styles.calc_card_title}>{item.title}</b>
              </RootDesc>

              <p
                className={`${styles.calc_card_value} ${
                  item.id === 3 ? styles.calc_card_value_roi : ""
                }`}
              >
                {item.value}
              </p>

              <RootDesc>
                <span
                  className={styles.calc_card_description}
                  dangerouslySetInnerHTML={{__html: item.description}}
                />
              </RootDesc>
            </BorderArticle>
          </React.Fragment>
        ))}
      </div>
    </BorderArticle>
  );
};
